import { createRouter as _createRouter, createWebHistory } from 'vue-router'
import Home from '@/app/core/Home.vue'
import Invitation from '@/app/core/Invitation.vue'

export function createRouter() {
    const routes = [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/:token/',
            name: 'Your invitation',
            component: Invitation
        },
        {
            path: '/:pathMatch(.*)*/',
            redirect: '/',
        },
    ]

    const router = _createRouter({
        history: createWebHistory('/'),
        routes,
    })

    return router
}